import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components/Toast'
import { CTR } from '~bank-bsa-reporting/service'

import { handlerServerError } from '@orbit/errors'

export const useCTRApprove = (onSuccess: () => void, onError: () => void) =>
  useMutation({
    mutationFn: CTR.approveCTR,
    onSuccess: async () => {
      Toast.successSmall('The CTR was approved successfully')
      await onSuccess()
    },
    onError: (error) => {
      handlerServerError(error)
      onError()
    }
  })
